@if (canSwitchHospitals) {
<button mat-menu-item [matMenuTriggerFor]="hospitalSwitcherMenu">
    <mat-icon>local_hospital</mat-icon>
    <span>Switch hospital</span>
</button>
}

<mat-menu #hospitalSwitcherMenu="matMenu" (menuOpened)="onMenuOpened()">
  @if (isLoadingHospitals) {
    <button mat-menu-item disabled>
      <mat-icon>hourglass_empty</mat-icon>
      <span>Loading hospitals…</span>
    </button>
  } @else if (hospitalLoadError) {
    <button mat-menu-item disabled>
      <mat-icon>error_outline</mat-icon>
      <span>Failed to load hospitals</span>
    </button>
  } @else if (myHospitals.length === 0) {
    <button mat-menu-item disabled>
      <mat-icon>info_outline</mat-icon>
      <span>No hospitals found</span>
    </button>
  } @else {
    @for (hospital of myHospitals; track hospital.hospitalFhirId) {
      <button mat-menu-item [disabled]="isSwitchingHospital" (click)="switchHospital(hospital)">
        <mat-icon>{{ hospital.isCurrent ? 'radio_button_checked' : 'radio_button_unchecked' }}</mat-icon>
        <span>{{ hospital.hospitalName }}</span>
      </button>
    }
  }
</mat-menu>